import { render, staticRenderFns } from "./USDTIntro.vue?vue&type=template&id=361b4e8c&scoped=true&"
import script from "./USDTIntro.vue?vue&type=script&lang=js&"
export * from "./USDTIntro.vue?vue&type=script&lang=js&"
import style0 from "./USDTIntro.vue?vue&type=style&index=0&id=361b4e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361b4e8c",
  null
  
)

export default component.exports